import _Symbol$for from "@babel/runtime-corejs3/core-js/symbol/for";
import React from "react";
const $counter = _Symbol$for('@xo-union/ui-accessibility/useDescriptionNode--counter');
const useDescriptionNode = (id, description) => {
  React.useEffect(() => {
    let node = document.getElementById(id);
    if (!node) {
      node = document.createElement('div');
      node.style.display = 'none';
      node.setAttribute('aria-hidden', 'true');
      document.body.appendChild(node);
      node.setAttribute('id', id);
      node.textContent = description;
    }
    node[$counter] = node[$counter] || 0;
    node[$counter] += 1;
    return () => {
      node[$counter] -= 1;
      if (node[$counter] === 0) {
        document.body.removeChild(node);
      }
    };
  }, [id, description]);
};
export default useDescriptionNode;